import React, { useState, useEffect } from 'react';
import { DirectionalHint, Coachmark, TeachingBubble, TeachingBubbleContent, useTheme } from '@fluentui/react';

import { autorun, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';


export { Version } from 'src/stores/coachmarkStore';


function TeachingCoachmarkImpl({ 
  target, id, theme: initialTheme, directionalHint = DirectionalHint.bottomAutoEdge,
  coachmarkStore, coachmarkProps = {}, teachingBubbleProps = {} 
}) {
  const getItem = () => coachmarkStore.getStep(id);

  const theme = initialTheme ?? useTheme();
  const [bubbleData, setBubbleData] = useState(getItem());

  useEffect(() => autorun(() => {
    coachmarkStore.activeSteps;
    setBubbleData(getItem());
  }), []);

  if (!target || !bubbleData || bubbleData.isDismissed) {
    return null;
  }

  const { text, isCollapsed = true, teachingBubbleProps: teachingBubbleDataProps } = bubbleData;

  return (
    <Coachmark
      target={target}
      isCollapsed={isCollapsed}
      positioningContainerProps={{
        directionalHint,
        doNotLayer: false,
      }}
      persistentBeak={true}
      delayBeforeMouseOpen={2000}
      theme={theme}
      {...coachmarkProps}
    >
      <TeachingBubbleContent
        target={target}
        hasCloseButton={true}
        theme={theme}
        isWide={false}
        styles={{ body: { maxWidth: '240px' } }}
        {...teachingBubbleDataProps}
        {...teachingBubbleProps}
      >
      {text}
      </TeachingBubbleContent>
    </Coachmark>)
  ;
}


export const TeachingCoachmark = inject('coachmarkStore')(observer(TeachingCoachmarkImpl));
export default TeachingCoachmark;